import { render, staticRenderFns } from "./DevolvidoStatusModal.vue?vue&type=template&id=54b17956&scoped=true"
import script from "./DevolvidoStatusModal.vue?vue&type=script&lang=js"
export * from "./DevolvidoStatusModal.vue?vue&type=script&lang=js"
import style0 from "./DevolvidoStatusModal.vue?vue&type=style&index=0&id=54b17956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b17956",
  null
  
)

export default component.exports